@if (display) {
	<p-dialog [styleClass]="authenticationService?.user?.fontSize === 'SMALL' ? 'custom-form-small' : (authenticationService?.user?.fontSize === 'MEDIUM' ? 'custom-form-medium' : '')" header="{{ 'control-panel.maintenance-plans.maintenancePlan' | translate }}" (onAfterHide)="onHide($event)" [(visible)]="display" showEffect="fade" [modal]="true" [style]="{ width: '24vw' }">
		<div class="ui-grid ui-grid-responsive ui-fluid" [ngClass]="{'custom-form-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-form-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">
			<div class="ui-grid-row">
				<div class="ui-grid-col-12">
					@for (msg of messages; track msg) {
						<p-message [severity]="msg.severity" [text]="msg.detail"></p-message>
					}
				</div>
			</div>
			<div class="mt-3">
				<div class="ui-g">
					<div class="ui-g-12 ui-md-6">
						<form-input
							[required]="true"
							i18n-fieldName
							fieldName="{{ 'tableManagement.vehicleStatus.form.name' | translate }}"
							[errors]="errors.name"
						>
							<input pInputText id="name" [(ngModel)]="entity.name" />
						</form-input>
					</div>
					<div class="ui-g-12 ui-md-6 mt-2">
						<form-input
							i18n-fieldName
							fieldName="{{ 'control-panel.poi-categories.poiEnabled' | translate }}"
							[errors]="errors.enabled"
						>
							<p-checkbox disabled="true" [(ngModel)]="entity.enabled" binary="true"></p-checkbox>
						</form-input>
					</div>
				</div>
			</div>
		</div>
		<ng-template pTemplate="footer">
			<div class="d-flex justify-content-center bd-highlight">
				<div class="p-2 bd-highlight">
					@if (disableSave == false) {
						<div>
							<button
								type="button"
								pButton
								icon="fa fa-check"
								(click)="save()"
								i18n-label
								label="{{ 'general.save' | translate }}"
							></button>
						</div>
					}
					@if (disableSave == true) {
						<div>
							<div
								style="display: inline-block"
								i18n-pTooltip
								pTooltip="No permissions to update"
								tooltipPosition="top"
							>
								<button
									disabled="true"
									type="button"
									pButton
									icon="fa fa-check"
									(click)="save()"
									i18n-label
									label="{{ 'general.save' | translate }}"
								></button>
							</div>
						</div>
					}
				</div>
				@if (isNew == false) {
					<div class="p-2 bd-highlight">
						<button
							[disabled]="disableChangeStatus"
							type="button"
							pButton
							icon="fa fa-check"
							(click)="changeStatus(!entity.enabled)"
							i18n-label
							label="{{ 'general.changeStatus' | translate }}"
						></button>
					</div>
				}
			</div>
		</ng-template>
	</p-dialog>
}
